import React, {
  useEffect, useState, useCallback, memo, useRef, useContext,
} from 'react';
import {useDispatch} from 'react-redux';
import {ActionChangeLanguage} from '../../store/actions/actions-pages';
import {LanguageContext} from '../../context/LanguageContext';

import './LanguageSelect.less';

const lngData = [
  {
    label: 'Рус',
    language: 'ru',
  },
  {
    label: 'Eng',
    language: 'en',
  },
];

function LanguageSelect() {
  const language = useContext(LanguageContext);

  const dispatch = useDispatch();

  const wrapperRef = useRef();

  const [isOpen, changeState] = useState(false);

  const selectLanguage = useCallback((lng) => {
    localStorage.setItem('language', lng);
    dispatch(ActionChangeLanguage(lng));
  }, []);

  const languageClickHandle = useCallback(() => {
    changeState(!isOpen);
  }, [isOpen]);

  const handleClickOutside = useCallback((e) => {
    if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
      changeState(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div role="button" className="right-panel-item lang-wrap" onClick={languageClickHandle} ref={wrapperRef}>
      <div className="lang-active">
        <div className={`lang-active_img-wrap ${language}`} />
        <span className="lang-name">{language === 'ru' ? 'Рус' : 'Eng'}</span>
      </div>
      <ul className={`lang-list ${isOpen ? 'visible' : ''}`}>
        {lngData.map((lng) => (
          <li
            key={lng.language}
            className={`lang-list_item lang-${lng.language}`}
            onClick={() => selectLanguage(lng.language)}
          >
            <div className={`ling-list_img-wrap ${lng.language}`} />
            <span className="lang-names">{lng.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default memo(LanguageSelect);
